import * as React from 'react';
import cn from 'classnames';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden';
import { State } from '../../types';
import { getStateClasses, getOutlineClasses } from '../../utils/taillwind';
import './Badge.css';

export type BadgeProps = React.HTMLAttributes<HTMLSpanElement> & {
    /** Content should be a numerical value or tag/status like text **/
    children: React.ReactNode;
    /** Show compact version **/
    compact?: boolean;
    /** Show outlined version **/
    outline?: boolean;
    /** State will change the style of the badge **/
    state?: State;
};

export const Badge = React.forwardRef(function Badge(props: BadgeProps, ref: React.Ref<HTMLSpanElement>) {
    const { children, compact = false, outline = false, state, ...otherProps } = props;
    const className = cn(
        'yt-badge',
        {
            [getStateClasses(state)]: !outline,
            [getOutlineClasses(state)]: outline,
            'yt-badge--compact': compact,
        },
        props.className
    );

    return (
        <span
            {...otherProps}
            aria-atomic="true"
            aria-live="polite"
            className={className}
            ref={ref}
            role="status"
            title={props['aria-label']}>
            {compact ? <VisuallyHidden>{children}</VisuallyHidden> : children}
        </span>
    );
});
